import { __decorate } from "tslib";
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    dialogItem;
    canvas;
    id = '1';
    imgHeight = 0;
    imgWidth = 0;
    boxWidth = 606;
    boxHeight = 350;
    mounted() {
        this.getImg_info();
        // this.drawCan();
    }
    getImg_info() {
        let img_url = this.dialogItem.panoramicImage;
        var img = new Image();
        // 改变图片的src
        img.src = img_url;
        // 判断是否有缓存
        if (img.complete) {
            // 打印;
            this.imgHeight = img.height;
            this.imgWidth = img.width;
            this.drawCan();
            // alert('from:complete : width:' + img.width + ',height:' + img.height);
        }
        else {
            // 加载完成执行
            img.onload = () => {
                // 打印
                this.imgHeight = img.height;
                this.imgWidth = img.width;
                this.drawCan();
                // alert('from:onload : width:' + img.width + ',height:' + img.height);
            };
        }
    }
    drawCan() {
        // let canvas = document.getElementById(this.id) as HTMLCanvasElement;
        setTimeout(() => {
            let canvas = document.getElementById(this.id);
            let cxt = canvas.getContext('2d');
            canvas.width = this.boxWidth;
            canvas.height = this.boxHeight;
            //   console.log(cxt);
            cxt.clearRect(0, 0, canvas.width, canvas.height);
            let item = this.dialogItem;
            let fromX = (item.faceBoundingPoly.vertices[0].x / this.imgWidth) * this.boxWidth;
            let fromY = (item.faceBoundingPoly.vertices[0].y / this.imgHeight) * this.boxHeight;
            let toX = (item.faceBoundingPoly.vertices[1].x / this.imgWidth) * this.boxWidth;
            let toY = (item.faceBoundingPoly.vertices[1].y / this.imgHeight) * this.boxHeight;
            let width = Math.abs(toX - fromX);
            let height = Math.abs(toY - fromY);
            //   console.log(fromX, fromY, width, height);
            this.draw(cxt, fromX, fromY, width, height);
        }, 1);
    }
    draw(cxt, fromX, fromY, width, height) {
        cxt.lineWidth = 2;
        cxt.strokeStyle = 'red';
        cxt.strokeRect(fromX, fromY, width, height);
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogItem", void 0);
__decorate([
    Ref()
], default_1.prototype, "canvas", void 0);
default_1 = __decorate([
    Component({
        name: 'face',
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], default_1);
export default default_1;
